import { render } from "./DefaultButton.vue?vue&type=template&id=492f6da6&scoped=true"
import script from "./DefaultButton.vue?vue&type=script&lang=js"
export * from "./DefaultButton.vue?vue&type=script&lang=js"

import "./DefaultButton.vue?vue&type=style&index=0&id=492f6da6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492f6da6"],['__file',"src/components/button/DefaultButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "492f6da6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('492f6da6', __exports__)) {
    console.log('reload')
    api.reload('492f6da6', __exports__)
  }
  
  module.hot.accept("./DefaultButton.vue?vue&type=template&id=492f6da6&scoped=true", () => {
    console.log('re-render')
    api.rerender('492f6da6', render)
  })

}


export default __exports__